import React from 'react'
import InputCustom from '../../../../components/elements/InputCustom'
import SelectDropDown from '../../../../components/elements/SelectDropDown'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';

function ReceiveInfo({ state, setStateCustom1, fakData }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    return (
        <div className='d-flex'>
            <div className='w-25' >
                <InputCustom
                    label='delivery_number'
                    iconType='pencil'
                    type='number'
                    value={fakData?.receiver?.delivery_number}
                    onChange={(e) => setStateCustom1('receiver.delivery_number', e.target.value)}
                />
            </div>
            <div className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('received_by')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "person 1" }, { value: '2', label: "person 2" }]}
                    varr={`receiver.received_by`}
                    defaultvalue={{ value: fakData?.receiver?.received_by?.value, label: fakData?.receiver?.received_by?.label }}
                    setStateCustom={setStateCustom1}
                />
            </div>
            <div className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('received_on')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "person 1" }, { value: '2', label: "person 2" }]}
                    varr={`receiver.received_on`}
                    defaultvalue={{ value: fakData?.receiver?.received_on?.value, label: fakData?.receiver?.received_on?.label }}
                    setStateCustom={setStateCustom1}
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='phone_number'
                    iconType='phone'
                    type='number'
                    value={fakData?.receiver?.phone_number}
                    onChange={(e) => setStateCustom1('receiver.phone_number', e.target.value)}
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='notes'
                    iconType='book'
                    value={fakData?.receiver?.notes}
                    type='text'
                    onChange={(e) => setStateCustom1('receiver.notes', e.target.value)}
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='SN'
                    iconType='pencil'
                    value={fakData?.receiver?.sn}
                    type='text'
                    onChange={(e) => setStateCustom1('receiver.sn', e.target.value)}
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='photo_identification'
                    iconType='image'
                    type='file'
                    onChange={(e) => setStateCustom1('receiver.photo_identification', e.target.files[0])}
                />
            </div>
        </div>
    )
}

export default ReceiveInfo